export interface IData {
  _id: string;
  name: string;
  email: string;
  ticketId: string;
  mobileNumber: string;
  status: StatusFilterEnum;
  message: string;
  createdAt: string;
  updatedAt: string;
}
export enum StatusFilterEnum {
  ALL = 0,
  OPEN = 1,
  CLOSE = 2,
  PENDING = 3
}
export interface SupportState {
  List: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  status: StatusFilterEnum;
}

export type InitialState = SupportState;
